import { render } from "./SolutionsPage.vue?vue&type=template&id=05160cda&scoped=true"
import script from "./SolutionsPage.vue?vue&type=script&lang=js"
export * from "./SolutionsPage.vue?vue&type=script&lang=js"

import "./SolutionsPage.vue?vue&type=style&index=0&id=05160cda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05160cda"]])

export default __exports__